module.exports = __webpack_public_path__ + "img/racetrack-borrowdalePark-turf.2fe69478.svg";